















































import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'AssessmentEditor',
  props: {
    assessment: {
      type: Object,
      default: {
        id: null,
        name: "Not yet loaded...",
        questions: []
      }
    }
  },
  data () {
    return {
      ax: {
        id: null,
        name: "Not yet loaded...",
        questions: []
      },
    }
  },
  computed: {
    ...mapGetters([
      'riskLevels',
    ]),
    riskLevelOptions () {
      const options = []
      for (let r=0, l=this.riskLevels.length; r<l; r++) {
        options.push({ value: r, text: `${r} - ${this.riskLevels[r]}` })
      }
      return options
    }
  },
  methods: {
    emitChange () {
      this.$emit('change', this.ax)
    }
  },
  mounted () {
    if (this.assessment) {
      this.ax = JSON.parse(JSON.stringify(this.assessment))
    }
  },
  watch: {
    assessment (newVal: Assessment) {
      this.ax = JSON.parse(JSON.stringify(newVal))
    }
  }
}
